module.exports = __webpack_public_path__ + "static/img/48.0afa5c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/gallery/16/48.jpg
// module id = 709
// module chunks = 0